import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';

import { NEW_CONSULTATION } from 'FRONTEND/actions/constants';
import { exitConsultationView } from 'FRONTEND/reducers/consultationViewSlice';
import { getConsultation } from 'FRONTEND/utils/backendApi/consultationApi';

const REDUCER_NAME = 'consultation';

const consultationRead = createAsyncThunk(`${REDUCER_NAME}/read`, async(consultationParams, { getState }) => {
  const { consultation, attachmentList } = await getConsultation(consultationParams);
  return {
    consultation,
    attachmentList,
  };
});

export const initialState = {
  currentConsultation: {
    id: null,
    consultationId: null,
    type: null,
    patient: null,
    lastEvent: null,
    status: null,
    attachmentIdList: [],
    downloads: [],
    participants: [],
    participantsRequestList: [],
    eventList: [],
    missionName: null,
    unread: null,
    projectName: null,
    transitions: [],
    isDraft: null,
    surveillanceList: [],
    workflow: null,
    version: null,
    consultationTimezone: null,
    isTesting: null,
  },
  attachmentList: [],
  highlightedConsultationId: null,
  consultationReminderModalOpenId: null,
};

export const selectSurveillanceDataForCurrentConsultation = createSelector(
  (state) => state.consultation.currentConsultation.surveillanceList,
  (surveillanceList) => surveillanceList.toSorted((a, b) => b.date - a.date),
);

const slice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    initConsultationsState(state, action) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
    clearConsultationHighlight(state) {
      state.highlightedConsultationId = null;
    },
    openConsultationReminderModal(state, { payload: consultationId }) {
      state.consultationReminderModalOpenId = consultationId;
    },
    closeConsultationReminderModal(state) {
      state.consultationReminderModalOpenId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(consultationRead.fulfilled, (state, { payload: { consultation, attachmentList } }) => {
      state.currentConsultation = consultation;
      state.attachmentList = attachmentList;
    });
    builder.addCase(exitConsultationView, (state) => {
      state.currentConsultation = initialState.currentConsultation;
      state.attachmentList = [];
    });
    builder.addCase(NEW_CONSULTATION, (state, action) => {
      state.highlightedConsultationId = action.payload.id;
    });
  },
});

export {
  consultationRead,
};

export const {
  initConsultationsState,
  clearConsultationHighlight,
  openConsultationReminderModal,
  closeConsultationReminderModal,
} = slice.actions;


export default slice.reducer;
